const headers = (idSearch, employeeCodeSearch, employeeNameSearch = "", departmentNameSearch="", divisionNameSearch="") =>  {
  return [
    {text:"", value: "actions"},
    { text: 'Mã ID', value: 'id', align: 'start', sortable: true, width: 100,
      filter: value => {
        if (!idSearch) return true
  
        return value == idSearch
      },
    },
    { text: 'Mã nhân viên', value: 'employeeCode', width: 120,
      filter: value => {
        if (!employeeCodeSearch) return true
  
        return value.includes(employeeCodeSearch)
      },
    },
    { text: 'Tên nhân viên', value: 'employeeName', width: 150, 
      filter: value => {
        if (!employeeNameSearch) return true
  
        return value.includes(employeeNameSearch)
      },
    },
    { text: 'Phòng ban', value: 'departmentName', width: 150, 
      filter: value => {
        if (!departmentNameSearch) return true
        if(value == null) return true
  
        return value.includes(departmentNameSearch)
      },
    },
    { text: 'Bộ phận', value: 'divisionName', width: 150, 
      filter: value => {
        if (!divisionNameSearch) return true
        if(value == null) return true
  
        return value.includes(divisionNameSearch)
      },
    },
    { text: 'Ngày làm việc', value: 'workDate' },
    { text: 'Hình ảnh', value: 'imageUrl' },
    { text: 'Lý do', value: 'reasonTypeName', width: 250 },
    { text: 'Giờ đã xác nhận', value: 'confirmedWorktime', width: 150},
    { text: 'Ghi chú', value: 'note', width: 300 },
    { text: 'Giờ cần xác nhận', value: 'worktime', width: 100},
    { text: 'Ngày tạo', value: 'createdAt', type: 'date' },
    { text: 'Quản lý trực tiếp', value: 'managerName' },
    { text: 'Nhân sự phụ trách', value: 'hrAdminName' },
    { text: 'Giám đốc nhân sự', value: 'hrManagerName' },
    // { text: 'Trạng thái', value: 'confirmLevel' },
    // { text: 'Người từ chối', value: 'rejectedByCode' },
  ]
}
export default headers;